import useVuelidate from '@vuelidate/core';
import { TypeCampaignEnum } from '@/types';
import { requiredWithMessage, includesValuesValidator } from '@/helpers/CustomValidator';
import type { FlowOperatorMetadata, ValidationResult } from '@/types/flow-types';
import { canDeleteTrigger } from '@/components/flows/operators/registry';
import Form from './Form.vue';

export interface QuitSiteData {
  multiplebox_type: string;
}

export function createDefaultData(data: Partial<QuitSiteData> = {}): QuitSiteData {
  return {
    multiplebox_type: data.multiplebox_type ?? '0',
  };
}

const QuitSite: FlowOperatorMetadata<QuitSiteData> = {
  id: 'boxquitsite',
  kind: 'trigger',
  label: 'flows.operators.quitSite.label',
  icon: 'fa-sign-out',
  hasConfiguration: true,
  availableIn: [],
  hidden: true,

  incompatibilities: {
    [TypeCampaignEnum.AUTOMATION]: {
      nextOperators: [
        'boxabandonpanier', 'boxsitepasstime', 'boxquitsite',
        'boxperiodiclaunching', 'boxscrollpage', 'boxstatuscommand',
        'boxcustomjs', 'boxregisteronsite', 'boxsubscribetonewsletter',
        'boxsendemail', 'boxsendsms', 'boxsendfbmessenger',
        'boxsendpushnotification', 'openemail', 'clicklink',
        'boxvisitpage', 'boxtriggerinternalevent', 'boxsendrcs', 'boxsendwhatsapp',
      ],
    },
  },

  Form,

  defaultData: createDefaultData,

  outputs: () => 1,

  async validate(data: QuitSiteData): Promise<ValidationResult> {
    const rules = {
      multiplebox_type: {
        requiredWithMessage: requiredWithMessage(),
        includesValuesValidator: includesValuesValidator(['0', '1']),
      },
    };

    const v$ = useVuelidate(rules, data);
    const success = await v$.value.$validate();
    return {
      success,
      validate: v$,
    };
  },

  canBeDeleted(operatorId: string, flow: any): Promise<boolean | string> {
    return canDeleteTrigger(flow, operatorId);
  },
};

export default QuitSite;
